import { IconConfig } from "../types"

export const receiptText: IconConfig = {
  type: 'stroke' as const,
  viewBox: "0 0 24 24",
  paths: [
    "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z",
    "M14 8H8",
    "M16 12H8",
    "M13 16H8"
  ] as const
}
